import { render, staticRenderFns } from "./TabelaContatos.vue?vue&type=template&id=6600cee1&scoped=true"
import script from "./TabelaContatos.vue?vue&type=script&lang=js"
export * from "./TabelaContatos.vue?vue&type=script&lang=js"
import style0 from "./TabelaContatos.vue?vue&type=style&index=0&id=6600cee1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600cee1",
  null
  
)

export default component.exports